import { Add } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { trackerUrls } from '@/tracker/config/urls';
import { StatusBadge } from '@/tracker/entities/status';
import { Task } from '@/tracker/types';

import { CardSection } from '../CardSection';
import { TaskPicker } from '../TaskPicker';
import { IssueCardStore } from '../../model/IssueCardStore';
import { useIssueDrawer } from '../../useIssueDrawer';

import s from './IssueSubtasks.module.scss';

type Props = {
  issue: Task;
  store: IssueCardStore;
};

/** Подзадачи: список со статусами, создание новой и привязка существующей */
const IssueSubtasks: React.FC<Props> = observer(({ issue, store }) => {
  const { issueLink } = useIssueDrawer();
  const [isAdding, setIsAdding] = useState(false);

  return (
    <CardSection title="Подзадачи" count={store.children.length}>
      {store.children.length > 0 && (
        <ul className={s.list}>
          {store.children.map((child) => (
            <li key={child.id} className={s.list__item}>
              <Link to={issueLink(child.key)} className={s.list__link}>
                {child.key}
              </Link>
              <span className={s.list__summary}>{child.summary}</span>
              <StatusBadge status={child.status} />
            </li>
          ))}
        </ul>
      )}
      {!store.isReadOnly && isAdding && (
        <div className={s.picker}>
          <TaskPicker
            search={store.searchTasks}
            ariaLabel="Подзадача"
            onSave={(key) => key && store.addChild(key)}
            onClose={() => setIsAdding(false)}
          />
        </div>
      )}
      {!store.isReadOnly && !isAdding && (
        <div className={s.actions}>
          <Link
            to={trackerUrls.newSubissue({ queueKey: issue.queue.key, parentKey: issue.key })}
            state={{ parent: { key: issue.key, summary: issue.summary } }}
            className={s.actions__action}
          >
            <Add fontSize="inherit" />
            Создать подзадачу
          </Link>
          {!store.isSaving && (
            <button type="button" className={s.actions__action} onClick={() => setIsAdding(true)}>
              <Add fontSize="inherit" />
              Привязать существующую
            </button>
          )}
        </div>
      )}
    </CardSection>
  );
});

export { IssueSubtasks };
